export default function createSlug(string, reverse) {
  if (reverse) {
    return string.split('-').join(' ').toLowerCase();
  }

  return string.split(' ').join('-').toLowerCase();
}
